.wrap {
  display: inline-flex;
  max-width: 100%;
}

.card {
  position: fixed;
  z-index: 70;
  top: 0;
  left: 0;
  visibility: hidden;
  width: max-content;
  max-width: min(320px, calc(100vw - 16px));
  padding: 10px 12px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-card);
  background: var(--panel);
  box-shadow: var(--shadow-pop);
  color: var(--ink);
  font-size: var(--t-dense);
  line-height: 1.4;
  animation: card-in 0.14s var(--ease-out) both;
}

@keyframes card-in {
  from {
    opacity: 0;
    transform: translateY(3px);
  }

  to {
    opacity: 1;
    transform: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .card {
    animation: none;
  }
}
